module.exports = __webpack_public_path__ + "img/apple-icon.b4605707.png";